export default {
  columns: {
    offerName: 'Nume ofertă',
    type: 'Tip',
    status: 'Stare',
    active: 'Activ',
    inactive: 'Inactiv',
    details: 'Detalii',
    schedule: 'Programare',
    startDate: 'Data de început',
    images: 'Imagine',
  },
  actions: {
    edit: 'Editează',
    rename: 'Redenumește',
    delete: 'Șterge',
    set_active: 'Setează activ',
    set_inactive: 'Setează inactiv',
    cancel: 'Anulează',
    confirm: 'Confirmă',
    activate: 'Înlocuiește & Activează',
    manage_images: 'Editează imaginea',
  },
  toasts: {
    offer_enabled: '{{offer}} este acum oferta activă pentru {{for}}',
    offer_disabled: '{{offer}} setat ca Inactiv.',
    update_failed: 'Actualizarea ofertei a eșuat.',
    successfully_deleted: 'Oferta a fost ștearsă cu succes',
    delete_failed: 'Ștergerea ofertei a eșuat',
  },
  title: 'Gestionează toate ofertele',
  popups: {
    delete: {
      title: 'Sigur doriți să ștergeți această ofertă?',
    },
    toggle: {
      title_overlapping_is_not_allowed: 'Înlocuirea ofertelor principale nu este permisă',
      title: 'Înlocuiți oferta activă pentru această perioadă?',
      description:
        'Activați {{offer}} în {{weekday}}{{between}}. Aceasta va dezactiva oferta activă curentă {{currentOffer}} pentru aceeași perioadă.',
      between: ', între {{start}}-{{end}}',
    },
  },
};
